import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LOGO_MARK } from "../lib/brand";
import { LogoMark } from "../components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        setError("Login fehlgeschlagen. Bitte erneut versuchen.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center" data-testid="auth-callback-loading">
        <LogoMark src={LOGO_MARK} size="w-14 h-14" className="mx-auto animate-pulse" />
        <div className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">
          Authentifizierung läuft…
        </div>
        {error && <div className="mt-3 text-red-400 text-sm">{error}</div>}
      </div>
    </div>
  );
}
